import { Form, Input, message, Modal, Select, Switch, Upload } from 'antd'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import CustomButton from '../../../components/CustomButton'
import { actionCreateAuthor, actionUpdatePostTag } from '../../../redux/post/actions'
import btnX from '../../assets/images/btnX.png'
import { convertToSlug } from '../../lib/common'
import TextArea from 'antd/lib/input/TextArea'
import { CaretDownOutlined } from '@ant-design/icons'
import { uploadOneFile } from '../../../redux/upload/actions'
const formRef = React.createRef()
function CreateUpdateAuthor(props) {
    const dispatch = useDispatch()
    const [status, setStatus] = useState(false)
    const { visibleModal, onCloseModal, recordModal, filterModal } = props
    const [dataInput, setDataInput] = useState(null)
    const [gender, setGender] = useState(null)
    const [facebook, setFacebook] = useState(null)
    const [zalo, setZalo] = useState(null)
    const [twitter, setTwitter] = useState(null)
    const [description, setDescrition] = useState(null)
    const [fileUpload, setFileUpload] = useState(null)
    const [oldFileUpload, setOldFileUpload] = useState('https://api.hanagold.vn/uploads/1641181437932-defaultImageDashed.png')

    useEffect(()=>{
        if (recordModal && recordModal.id) {
            const { fullname, gender, description, avatar, facebook, zalo, twitter } = recordModal
            
            formRef.current.setFieldsValue({
                fullname,
                gender,
                facebook: facebook,
                zalo: zalo,
                twitter: twitter,
                description : description ? description : '',
            })
            setStatus(recordModal?.status === 1 ? true : false)
            setOldFileUpload(avatar)
        }
    }, [dispatch, recordModal])

    const onChangTitle = (e) => {
        setDataInput(e.target.value)
        formRef.current.setFieldsValue({
            name: convertToSlug(e.target.value)
        })
    }

    const onSwitch = (value) => {
        setStatus(value)
    }

    const onSubmitDelayed = _.debounce(() => onSubmit(), 100)
    const onSubmit = async () => {
        await formRef.current.validateFields();
        let image = ""
        if (fileUpload) {
            let newUploadFile = new FormData();
            newUploadFile.append('file', fileUpload);
            image = await dispatch(uploadOneFile(newUploadFile))
        }
        let dataPush = {
            id: recordModal?.id,
            fullname: dataInput ?? recordModal?.fullname,
            // url: convertToSlug(dataInput),
            status: status === true ? 1 : 0,
            gender: gender ?? recordModal?.gender,
            facebook: facebook ?? recordModal?.facebook,
            zalo: zalo ?? recordModal?.zalo,
            twitter: twitter ?? recordModal?.twitter,
            description: description ?? recordModal?.description,
            avatar: image ?? recordModal?.avatar,
        }
        let messageSuccess = "Thêm mới thành công"
        //Sửa
        if (recordModal && recordModal.id) {
            dataPush = {
                id: recordModal.id,
                ...dataPush
            }
            messageSuccess = "Cập nhật thành công"
        }
        const res = actionCreateAuthor({
            dataPush,
            filterModal
        })

        await dispatch(res);
        console.log("res", res);
        if (res) {
            onCloseModal()
            return message.success(messageSuccess)
        }
    }
    const enterKeyPressed = (event) => {
        if (event.keyCode === 13) {
            onSubmit()
        }
    }
    const uploadProps = {
        // multiple: true,
        accept: "image/png,image/jpeg,image/svg+xml",
        beforeUpload: (file, fileList) => {
            if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
                message.error(`${file.name} is not a image file`);
                setTimeout(() => {
                    message.destroy()
                }, 2000);
                return;
            } else {
                if (file.size > 10000000) {
                    message.error("File size > 1 MB!")
                    setTimeout(() => {
                        message.destroy()
                    }, 2000);
                    return;
                }
                file.newImg = URL.createObjectURL(file)
                setFileUpload(file)
            }
            return false;
        }
    };
    return (
        <>
            <Modal visible={visibleModal} footer={(
                <div className='row-end'>
                    <CustomButton
                        className="customClearSearch border-none mr--10"
                        title="Thoát"
                        btnBgColor="#ff708d"
                        btnColor="#ffffff"
                        btnHoverBackground="#ff708d"
                        onClick={onCloseModal}
                    />
                    <CustomButton
                        title="Lưu"
                        btnBgColor="#3699ff"
                        btnColor="#ffffff"
                        btnHoverBackground="#187de4"
                        onClick={onSubmitDelayed}
                    />
                </div>
            )}
                closable={false}
                centered
                width={560}
                destroyOnClose
                bodyStyle={{ position: "relative" }}
                onCancel={onCloseModal}
                className="customModal"
                title={[
                    <div className="row-sb-center">
                        <span className="modal-title">{recordModal?.id ? "Chỉnh Sửa" : "Thêm Mới"} Tác Giả</span>
                        <div></div>
                        <img
                            src={btnX} alt="" className="c-p"
                            onClick={onCloseModal}
                        />
                    </div>
                ]}
            >
                <Form ref={formRef}>
                <div className="layout-form-header row">
                    <div className='col-sm-6 mb--16'>
                        <div className="customLabel">Tên tác giả {' '}
                            <span className="customRequired">*</span>
                        </div>
                        <Form.Item
                            name="fullname"
                            rules={[{
                                validator: (_, value) => {
                                    if (!value || value.trim() === '') {
                                        return Promise.reject('Vui lòng nhập tên tác giả')
                                    }
                                    return Promise.resolve()
                                }
                            }]}
                        >
                            <Input
                                onKeyDown={enterKeyPressed}
                                className="customInput width100"
                                placeholder="Nhập tên tác giả"
                                onChange={(e) => onChangTitle(e)}
                                value={dataInput || ""}
                                autoFocus
                            />
                        </Form.Item>
                    </div>
                    <div className='col-sm-6 mb--16'>
                        <div className="customLabel">Giới tính</div>
                        <Form.Item
                            name="gender"
                        >
                            <Select
                                className="customSelect"
                                suffixIcon={<CaretDownOutlined />}
                                placeholder="Chọn giới tính"
                                value={gender || ""}
                                onChange={(e)=>{setGender(e)}}
                            >
                                <Select.Option value={1}>Nam</Select.Option>
                                <Select.Option value={0}>Nữ</Select.Option>
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-sm-6 mb--16">
                        <div className="customLabel">
                            Ảnh đại diện
                        </div>
                        <div className="rowy-center add-user-avatar">
                            <Upload {...uploadProps}>
                                <img
                                    src={fileUpload?.newImg || oldFileUpload} alt=""
                                    className="rad--4"
                                    style={{ objectFit: 'cover', width: '150px', height: '150px' }}
                                />
                            </Upload>
                        </div>
                    </div>
                    <div className="col-sm-6 mb--16">
                        <div className="customLabel">
                            Trạng thái{` `}
                        </div>
                        <div style={{ marginBottom: '20px' }}>
                            <Form.Item
                                name="status"
                            >
                                <Switch checked={status} onChange={onSwitch} /> <span style={{ marginLeft: '10px', fontWeight: '600' }}>{status === true ? 'Hoạt động' : 'Không hoạt động'}</span>
                            </Form.Item>
                        </div>
                    </div>
                    <div className='col-sm-12 mb--16'>
                        <div className="customLabel">Facebook{' '}<span className="customRequired">*</span></div>
                        <Form.Item
                            name="facebook"
                            rules={[{
                                validator: (_, value) => {
                                    if (!value || value.trim() === '') {
                                        return Promise.reject('Vui lòng nhập địa chỉ facebook')
                                    }
                                    return Promise.resolve()
                                }
                            }]}
                        >
                            <Input
                                onKeyDown={enterKeyPressed}
                                className="customInput width100"
                                placeholder="Nhập link facebook"
                                onChange={(e) => setFacebook(e.target.value)}
                                value={facebook || ""}
                                autoFocus
                            />
                        </Form.Item>
                    </div>
                    <div className='col-sm-12 mb--16'>
                        <div className="customLabel">Zalo{' '}<span className="customRequired">*</span></div>
                        <Form.Item
                            name="zalo"
                            rules={[{
                                validator: (_, value) => {
                                    if (!value || value.trim() === '') {
                                        return Promise.reject('Vui lòng nhập địa chỉ zalo')
                                    }
                                    return Promise.resolve()
                                }
                            }]}
                        >
                            <Input
                                onKeyDown={enterKeyPressed}
                                className="customInput width100"
                                placeholder="Nhập link zalo"
                                onChange={(e) => setZalo(e.target.value)}
                                value={zalo || ""}
                                autoFocus
                            />
                        </Form.Item>
                    </div>
                    <div className='col-sm-12 mb--16'>
                        <div className="customLabel">Twitter{' '}<span className="customRequired">*</span></div>
                        <Form.Item
                            name="twitter"
                            rules={[{
                                validator: (_, value) => {
                                    if (!value || value.trim() === '') {
                                        return Promise.reject('Vui lòng nhập địa chỉ twitter')
                                    }
                                    return Promise.resolve()
                                }
                            }]}
                        >
                            <Input
                                onKeyDown={enterKeyPressed}
                                className="customInput width100"
                                placeholder="Nhập link twitter"
                                onChange={(e) => setTwitter(e.target.value)}
                                value={twitter || ""}
                                autoFocus
                            />
                        </Form.Item>
                    </div>
                    <div className='col-sm-12 mb--16'>
                        <div className="customLabel">Thông tin tác giả</div>
                        <Form.Item
                            name="description"
                        >
                            <TextArea
                                onKeyDown={enterKeyPressed}
                                className="customInput width100"
                                placeholder="Nhập thông tin tác giả"
                                onChange={(e) => setDescrition(e.target.value)}
                                value={description || ""}
                                autoFocus
                                autoSize
                            />
                        </Form.Item>
                    </div>
                    </div>
                </Form>
            </Modal>
        </ >
    )
}
export default CreateUpdateAuthor